import React, { memo } from "react";
import { DeliverySpeedNudge as PocketHeroNudge } from "@swiggy-private/cart-types";
import DeliverySpeedNudge from "@cart-ui/components/delivery-speed/components/delivery-speed-nudge";
import { isEmpty } from "@swiggy-private/js-utils";

interface CrossSellNudgeProps {
    nudge?: {
        crossSellNudge?: PocketHeroNudge;
        isCashback?: boolean;
    };
}

const CrossSellNudge = ({ nudge }: CrossSellNudgeProps) => {
    if (isEmpty(nudge?.crossSellNudge?.message)) {
        return null;
    }
    return <DeliverySpeedNudge nudge={nudge?.crossSellNudge} isCrossSell isCashback={nudge?.isCashback} />;
};

export default memo(CrossSellNudge);
